var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('detail',{attrs:{"onManager":_vm.onManager,"data":_vm.data,"hiddenKeys":['updated_at', 'description'],"show-desc":false,"base-info":_vm.baseInfo,"extra-info":_vm.extraInfo}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }